import { AdminLog } from '@/domain/types/admin-log';
import { Column } from '@/presentation/components/table';

export const columnsAdminLogs: Column<AdminLog>[] = [
  {
    header: 'Fecha',
    accessor: 'timestamp',
    render: (_, data: AdminLog) => {
      const date = data.timestamp;
      return date instanceof Date
        ? date.toLocaleString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })
        : 'N/A';
    },
  },
  {
    header: 'Usuario',
    accessor: 'adminName',
    render: (_, data: AdminLog) => {
      return (
        <div>
          <div className="font-medium">{data.adminName}</div>
          <div className="text-sm text-gray-500">{data.adminEmail}</div>
        </div>
      );
    },
  },
  {
    header: 'Acción',
    accessor: 'action',
    render: (_, data: AdminLog) => {
      const action = data.action;
      const colorMap = {
        CREATE: 'bg-green-100 text-green-800',
        UPDATE: 'bg-blue-100 text-blue-800',
        DELETE: 'bg-red-100 text-red-800',
        RELEASE_TO_ALL: 'bg-purple-100 text-purple-800',
      };
      return (
        <span
          className={`px-2 py-1 rounded-full text-xs font-medium ${colorMap[action]}`}
        >
          {action}
        </span>
      );
    },
  },
  {
    header: 'Colección',
    accessor: 'collection',
    render: (_, data: AdminLog) => {
      return (
        <span className="px-2 py-1 bg-gray-100 text-gray-800 rounded text-xs">
          {data.collection}
        </span>
      );
    },
  },
  {
    header: 'Documento',
    accessor: 'documentTitle',
    render: (_, data: AdminLog) => {
      return (
        <div>
          <div className="font-medium truncate max-w-xs">
            {data.documentTitle || 'Sin título'}
          </div>
          <div className="text-xs text-gray-500 truncate max-w-xs">
            {data.documentId}
          </div>
        </div>
      );
    },
  },
];
